export const callEndedType = {
    userAlreadyInMeeting: {
        callId : 1,
        errorMessage : "Apologies for any inconvenience!! but it seems you are already in meeting!!"
    },
    UserLeftTheCall: {
        callId:2,
        errorMessage : "Thank you for attending! You've successfully left the meeting. If you have any further questions or need assistance, don't hesitate to ask. Have a wonderful day!"
    },
    meetingEnded: {
        callId:3,
        errorMessage : " Thank you for your participation! The meeting has concluded successfully. If you have any follow-up questions or action items, feel free to reach out. Have a great day!"
    }
  };
  